// hours can be be 1 decimal value

export const addHours = (date: Date, hours: number) => {
    const newDate = new Date(date);
    newDate.setTime(newDate.getTime() + hours * 60 * 60 * 1000);
    return newDate;
};